export const LABELS = {

    gasHandler: "Gas handlers",
    chargePump: "Charge pump",
    formulas: "Formulas",
    wellSurvey:"ESP assembly inputs",
    surfaceEquipment: "Surface equipment",
    wellInflowFormulas: "Well inflow formulas",
    wellIPRFormulas: "Well IPR formulas",
    tdhFormulas: "TDH formulas",
    pumpFormulas: "Pump formulas",
    fluidVelocityCheck: "Fluid velocity check",
    motorRating: "Motor rating",
    motorPerformmanceData: "Motor performance data",
    motorCalculations: "Motor calculations",
    harmonicFilter: "Harmonic filter",
    controller: "Controller",
    cableClearance: "Cable clearance",
    surfaceVoltage: "Surface voltage",
    OilContraction: "Oil contraction",
    protectorCalculations: "Protector calculations",

}